import apiService from "./apiService";
import AppConstants from "../appConstants";

class ReportTypeService {
    getAllReportType(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_REPORT_TYPE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getReportTypeDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_REPORT_TYPE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerReportType(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_REPORT_TYPE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteReportType(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_REPORT_TYPE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_REPORT_TYPE_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new ReportTypeService();
